const styles = theme => ({
  root: {
    height:0,
    marginTop: -7,
    align: 'center',
    textAlign: 'center',
  },
  textSize: {
    fontSize: 15,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/ServiceLevel/components/Header/components/Title/styles.js